/**
 * Types for the Tutorial Bank system in the frontend
 */
import {
  QuestionBankItem
} from '../../question-bank/types/question-bank.types';

/**
 * Video source types
 */
export enum VideoSourceType {
  UPLOADED = 'UPLOADED',
  YOUTUBE = 'YOUTUBE',
  VIMEO = 'VIMEO',
  EXTERNAL = 'EXTERNAL'
}

/**
 * Tutorial video interface
 */
export interface TutorialVideo {
  id: string;
  tutorialBankItemId: string;
  url: string;
  thumbnailUrl?: string;
  title: string;
  description?: string;
  duration?: number; // in seconds
  sourceType?: VideoSourceType; // Type of video source (uploaded, YouTube, Vimeo, etc.)
  createdAt: number;
  updatedAt: number;
}

/**
 * Tutorial Bank Item extends most of QuestionBankItem's properties
 * but adds a video property
 */
export interface TutorialBankItem extends Omit<QuestionBankItem, 'id' | 'status'> {
  id?: string;
  video?: TutorialVideo;
  status: TutorialBankItemStatus;
}

/**
 * Status options for tutorial bank items (same as question bank)
 */
export enum TutorialBankItemStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

/**
 * Tutorial bank test answer interface
 */
export interface TutorialBankTestAnswer {
  questionId: string;
  selectedOption: string;
  answeredAt: number;
  isCorrect: boolean;
}

/**
 * Tutorial bank progress interface
 */
export interface TutorialBankProgress {
  id: string;
  tutorialId: string;
  userId: string;
  categoryId: string;
  answers: TutorialBankTestAnswer[];
  startedAt: number;
  lastAccessedAt: number;
  completedAt?: number;
}
